import type { ReactNode } from "react";

import type { UiTheme } from "../theme";

// The one contract behind ZoomPanView.tsx (pinch and pan, native) and
// ZoomPanView.web.tsx (+/- buttons). Numbers and clamps live here once.

export const ZOOM_MIN = 1;
export const ZOOM_MAX = 4;
/** One press of the web +/- buttons. */
export const ZOOM_STEP = 0.5;
/** Travel before a one-finger drag pans the zoomed map instead of tapping.
 *  Under Android's scroll slop (8dp), so the page scroll never gets there first. */
export const PAN_MIN_DISTANCE = 4;

export const clampZoom = (z: number): number =>
  Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, z));

/** Content scaled by `z` around its centre can shift by half its overflow
 *  along an axis of length `len`, and no further. */
export const clampPan = (offset: number, len: number, z: number): number => {
  const max = Math.max(0, (len * (z - 1)) / 2);
  return Math.min(max, Math.max(-max, offset));
};

export type ZoomPanViewProps = {
  theme: UiTheme;
  /** Gets the width to fit the content to: the measured box on native (the
   *  transform does the zoom), the box times the zoom on web. `undefined`
   *  until the first layout. */
  children: (fitWidth: number | undefined) => ReactNode;
};
